import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getAllData } from "../../../lib/studentinfo";
import StudentTable from "./studenttable";
//import {useAuth} from "../../../usercontext";

export default function AdminStudentGrid() {
  const [profiles, setProfiles] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  //const { profile, setProfile } = useAuth();
  //const {companyId} = profile;
  const profilesPerPage = 50;

  console.log("useId()", Math.floor(Math.random() * Date.now()).toString(36));

  async function GetData() {
    const profiles = await getAllData();

    const sortedProfiles = profiles.sort((a, b) => {
      const nameA = a.name ? a.name : "";
      const nameB = b.name ? b.name : "";
      return nameA.localeCompare(nameB);
    });
    setProfiles(sortedProfiles);
    //console.log("profiles", profiles);
  }

  useEffect(() => {
    GetData();
  }, []);

  const convertToString = (value) => {
    return value !== undefined && value !== null
      ? String(value).toLowerCase()
      : "";
  };

  const filteredProfiles = profiles.filter(
    (profile) =>
      convertToString(profile.name).includes(searchTerm.toLowerCase()) ||
      convertToString(profile.schoolname).includes(searchTerm.toLowerCase()) ||
      convertToString(profile.class).includes(searchTerm.toLowerCase()) ||
      convertToString(profile.isActive).includes(searchTerm.toLowerCase())
  );

  const indexOfLastProfile = currentPage * profilesPerPage;
  const indexOfFirstProfile = indexOfLastProfile - profilesPerPage;
  const currentProfiles = filteredProfiles.slice(
    indexOfFirstProfile,
    indexOfLastProfile
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="col-12">
      <div className="row">
        <div className="settings-inner-blk p-2">
          <div className="d-flex align-items-center justify-content-between w-100">
            <div className="form-group mb-0">
              <h3>Students</h3>
            </div>
            <div className="export-cvv-btn">
              <Link
                to="/admin/admin-studentedit"
                className="btn btn-dark btn-dark-1"
                style={{ whiteSpace: "nowrap" }}
              >
                Create New Student
              </Link>
            </div>
          </div>
          <div className="student-search-form mt-2">
            <input
              type="text"
              className="form-control "
              placeholder="Search by name, school or class"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
        <table className="table table-hover">
          <thead>
            <tr>
              <th style={{ width: "10%", height: "60px" }}>Avatar</th>
              <th style={{ width: "25%", height: "60px" }}>Name</th>
              <th style={{ width: "35%", height: "60px" }}>School</th>
              <th style={{ width: "10%", height: "60px" }}>Class</th>
              <th style={{ width: "10%", height: "60px" }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {currentProfiles.map((data) => (
              <StudentTable key={data.id} data={data} />
            ))}
          </tbody>
        </table>
      </div>
      {/* pagination */}
      <div className="row">
        <div className="col-md-12">
          <ul className="pagination lms-page mt-0">
            {[
              ...Array(
                Math.ceil(filteredProfiles.length / profilesPerPage)
              ).keys(),
            ].map((page) => (
              <li
                key={page + 1}
                className={`page-item ${
                  currentPage === page + 1 ? "active" : ""
                }`}
              >
                <Link
                  className="page-link"
                  to="#;"
                  onClick={() => paginate(page + 1)}
                >
                  {page + 1}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
      {/* pagination */}
    </div>
  );
}
